interface SlideIndicatorProps {
  direction: 'left' | 'right';
  label: string;
  onClick: () => void;
  visible: boolean;
}

export default function SlideIndicator({ direction, label, onClick, visible }: SlideIndicatorProps) {
  if (!visible) return null;

  const isRight = direction === 'right';

  return (
    <button
      onClick={onClick}
      className={`fixed top-1/2 -translate-y-1/2 z-40 flex items-center gap-2 px-3 py-6 rounded-lg
        bg-white/5 border border-white/10 text-gray-400 hover:text-white hover:bg-white/15 hover:border-[var(--cyan-electric)]/50
        backdrop-blur-sm transition-all duration-300 group slide-hint-pulse
        ${isRight ? 'right-4' : 'left-4'}`}
      aria-label={label}
    >
      {!isRight && (
        <svg className="w-5 h-5 group-hover:-translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      )}
      <span className="writing-mode-vertical text-xs font-medium tracking-widest uppercase">
        {label}
      </span>
      {isRight && (
        <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      )}
    </button>
  );
}
